<script setup>
import apiManager from '@/api';
import {
  ref, computed, onMounted, onUnmounted,
} from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import { useStore } from 'vuex';
import DayOfView from '@/views/DayOfPage/DayOfPageView.vue';
import WaitingRoom from './WaitingRoom.vue';
import JoinModal from './JoinModal.vue';

const props = defineProps({
  id: String,
});

const statuses = {
  default: '',
  loading: 'loading',
  success: 'success',
  failed: 'failed',
};

const store = useStore();

const event = computed(() => store.getters['events/event'](props.id));

const status = ref(statuses.default);

const router = useRouter();
const register = () => router.push({ path: `/event/${props.id}/register` });

const resetJoin = () => { status.value = statuses.default; };

const signedIn = ref(false);
const validated = ref(false);
const dayOf = ref(false);

const showJoinModal = ref(false);

const toggleJoinModal = () => { showJoinModal.value = !showJoinModal.value; };

const join = () => {
  if (signedIn.value && event?.value.externalURLForLiveEvent) {
    window.open(event?.value.externalURLForLiveEvent, '_blank', 'noreferrer');
  } else if (signedIn.value) dayOf.value = true;
  else toggleJoinModal();
};

const email = computed(() => store.getters['user/email']);

const signIn = async (email_) => {
  try {
    await apiManager.events.signIn({
      eventId: props.id,
      email: email_,
    });
    store.commit('user/setEmail', email_);
    signedIn.value = true;
  } catch (e) {
    store.commit('user/setEmail', '');
    signedIn.value = false;
    throw new Error(e);
  } finally { validated.value = true; }
};

onMounted(() => {
  signIn(email.value);
});

const joinEvent = async (email_) => {
  status.value = statuses.loading;
  try {
    await signIn(email_);
    status.value = statuses.default;
    toggleJoinModal();
    join();
  } catch (e) {
    status.value = statuses.failed;
  }
};

const currentTime = ref(dayjs());
const intervalKey = ref('');

onMounted(() => {
  intervalKey.value = setInterval(
    () => { currentTime.value = dayjs(); },
    1000,
  );
});

onUnmounted(() => clearInterval(intervalKey));

</script>
<template>
  <join-modal v-if="showJoinModal"
    :statuses="statuses"
    :status="status"
    @join="joinEvent"
    @close="toggleJoinModal"
    @register="register"
    @try-again="resetJoin"
    />
  <template v-if="validated">
    <waiting-room v-if="!dayOf" :event="event" @join="join"
    :currentTime="currentTime" />
    <day-of-view v-else-if="signedIn && dayOf" :id="props.id" />
  </template>
</template>
